import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import NewsPage from "@/pages/news/page";
import NewsDetailPage from "@/pages/news/detail/page";
import WorksPage from "@/pages/works/page";
import WorkDetailPage from "@/pages/works/detail/page";
import CharactersPage from "@/pages/characters/page";
import CharacterDetailPage from "@/pages/characters/detail/page";
import AboutPage from "@/pages/about/page";
import SearchPage from "@/pages/search/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/news",
    element: <NewsPage />,
  },
  {
    path: "/news/detail/:id",
    element: <NewsDetailPage />,
  },
  {
    path: "/works",
    element: <WorksPage />,
  },
  {
    path: "/works/detail/:id",
    element: <WorkDetailPage />,
  },
  {
    path: "/characters",
    element: <CharactersPage />,
  },
  {
    path: "/characters/detail/:id",
    element: <CharacterDetailPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/search",
    element: <SearchPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;